






















import {
  Component, Emit, Model, Prop, PropSync, Vue,
} from 'vue-property-decorator';

@Component
export default class VueSmartSwitch extends Vue {
  @Model('change', { type: Boolean, required: false, default: false }) value!: boolean;

  name = 'VueSmartSwitch';

  onChange(value: boolean): void {
    this.$emit('change', value);
  }
}
